<h3>{{ 'admin.ov.titre' | traduire }}</h3>
<p class="sous-texte">{{ 'admin.ov.soustitre' | traduire }}</p>

<div class="stat-grid">
  <div class="stat-carte">
    <div class="chiffre">{{ nombreEvenements }}</div>
    <div class="label">{{ 'admin.ov.evenements' | traduire }}</div>
  </div>
  <div class="stat-carte">
    <div class="chiffre">{{ nombreArtistes }}</div>
    <div class="label">{{ 'admin.ov.artistes' | traduire }}</div>
  </div>
  <div class="stat-carte">
    <div class="chiffre">{{ nombreEditions }}</div>
    <div class="label">{{ 'admin.ov.editions' | traduire }}</div>
  </div>
  <div class="stat-carte" [class.alerte]="nombreTemoignagesAttente > 0">
    <div class="chiffre">{{ nombreTemoignagesAttente }}</div>
    <div class="label">{{ 'admin.ov.temoignagesAttente' | traduire }}</div>
  </div>
</div>

<div class="chart-grid">
  <div class="chart-carte">
    <h4>{{ 'admin.ov.parCategorie' | traduire }}</h4>
    <canvas #chartCategories width="380" height="200"></canvas>
  </div>
  <div class="chart-carte">
    <h4>{{ 'admin.ov.parEdition' | traduire }}</h4>
    <canvas #chartSpectateurs width="380" height="200"></canvas>
  </div>
</div>
